
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[primary_route]/[seconday_route]/[tertiary_route]",
      function () {
        return require("private-next-pages/[primary_route]/[seconday_route]/[tertiary_route]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[primary_route]/[seconday_route]/[tertiary_route]"])
      });
    }
  